import api from "./api";

// ===============================
// HOME SCREEN
// ===============================

export const getHomeData = async () => {
  const response = await api.get("/customer/home");
  return response.data;
};

// ===============================
// TODAY'S SPECIALS
// ===============================

export const getTodaysSpecials = async () => {
  const response = await api.get("/food/today");
  return response.data;
};

// ===============================
// POPULAR FOODS
// ===============================

export const getPopularFoods = async () => {
  const response = await api.get("/food/popular");
  return response.data;
};

// ===============================
// NEARBY PROVIDERS
// ===============================

export const getNearbyProviders = async () => {
  const response = await api.get("/provider/nearby");
  return response.data;
};

// ===============================
// FOOD CATEGORIES
// ===============================

export const getFoodCategories = async () => {
  const response = await api.get("/food/categories");
  return response.data;
};

// ===============================
// SERVICES
// ===============================

export const getServices = async () => {
  const response = await api.get("/customer/services");
  return response.data;
};

// ===============================
// OFFERS
// ===============================

export const getOffers = async () => {
  const response = await api.get("/offers");
  return response.data;
};

export const getActiveBanners = async () => {
  const response = await api.get("/campaigns/banners");
  return response.data;
};